
import templatePage from '@/app-template/lib/pages/NotificationDetailPage.vue';
export default {
  components: { templatePage },
};
